<template>
  <v-card outlined class="pa-2">
    <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
      <v-col cols="12" class="py-0">
        <v-row class="align-start">
          <v-col cols="12" class="py-0" v-for="(item, i) in order" :key="'item-pro'+i">
            <OrderProduct :lead="lead" :item="item" />
          </v-col>
          <v-col cols="12" class="py-1" v-if="!main">
            <v-row class="align-center">
              <v-col
                cols="12"
                :class="`${arabic?'arFont':'enFont'} text-left py-0`" style="font-size:12px;font-weight:bold;">
                <span>{{ i18n.order_total }}: {{ lead.total }} {{lead.currency_symbol}}</span>
              </v-col>
              <v-col
                cols="12"
                :class="`${arabic?'arFont':'enFont'} text-left success--text py-0`" style="font-size:12px;font-weight:bold;">
                <span>{{ i18n['total_net_profit_order'] }}: {{ lead.total_profit }} {{lead.currency_symbol}}</span>
              </v-col>
              <v-col
                cols="12"
                :class="`${arabic?'arFont':'enFont'} text-left success--text py-0`" style="font-size:12px;font-weight:bold;">
                <span>{{ i18n['total_net_profit_usd_order'] }}: {{ lead.base_profit }}$</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>

</template>

<script>
import OrderProduct from './OrderProduct'

export default {
  props:['lead', 'order', 'main'],
  components: { OrderProduct },
  data(){
    return {
      dialog:true,
    }
  },
  computed:{
    master(){
      return this.user.role == 'master'
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>